import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { CommonModule, DatePipe, Location } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';

export const DATE_FORMATS = {
  display: {
    dateInput: 'DD-MM-yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy'
  }
};
import { SettingData } from '../../../models/settings.model';
import { GlobalVariablesService } from '../../../global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../share-data/shared.service';
import { APIService } from '../../backend-service/backend-service';
import { HttpResponse } from '@angular/common/http';
import { NotificationService } from '../../../shared/services/notification.service';
import { LoadingService } from '../../../services/loading.service';
import { environment } from '../../../../environments/environment';
import { PhoneFormatPipe } from '../../../shared/pipes/phone-format.pipe';
import { SettingService } from '../../../settings/setting-service';

@Component({
  selector: 'app-truck-registration',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMomentDateModule,
    PhoneFormatPipe
  ],
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: DATE_FORMATS }
  ],
  templateUrl: './truck-registration.component.html',
  styleUrl: './truck-registration.component.scss'
})
export class TruckRegistrationComponent implements OnDestroy {
  truckTypeOptions: SettingData[] = [];
  truckTypeSelectedValue: SettingData = { id: '', name: '' };
  truckModelOptions: SettingData[] = [];
  truckModelSelectedValue: SettingData = { id: '', name: '' };
  filteredTruckModelOptions: SettingData[] = [];
  truckModelSearchText: string = '';
  truckLoadCapacityOptions: SettingData[] = [];
  truckLoadCapacitySelectedValue: SettingData = { id: '', name: '' };
  boxSizeOptions: SettingData[] = [];
  boxSizeSelectedValue: SettingData = { id: '', name: '' };
  boxLoadingTypeOptions: SettingData[] = [];
  boxLoadingTypeSelectedValue: SettingData = { id: '', name: '' };
  vehicleOptions: SettingData[] = [];
  vehicleSelectedValue: SettingData = { id: '', name: '' };
  incidentReportOptions: SettingData[] = [];
  incidentReportSelectedValue: SettingData = { id: '', name: '' };
  typeInsuranceOptions: SettingData[] = [];
  typeInsuranceSelectedValue: SettingData = { id: '', name: '' };
  securityDepositeAmountOptions: SettingData[] = [];
  securityDepositeSelectedValue: SettingData = { id: '', name: '' };
  selectedFiles!: File;
  selectedFilesList: File[] = [];
  truckProfilePicture: File | null = null;

  gpsOptions = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
  gpsSelected: { label: string; value: boolean } = this.gpsOptions[1];

  cameraOptions = [{ label: 'Yes', value: true }, { label: 'No', value: false }];
  cameraSelected: { label: string; value: boolean } = this.cameraOptions[1];

  fuelTypeOptions = [
    { label: 'EV', value: 'EV' },
    { label: 'Gas', value: 'GAS' },
    { label: 'HEV', value: 'HEV' },
    { label: 'Petrol', value: 'PETROL' },
    { label: 'Diesel', value: 'DIESEL' },
  ];
  fuelTypeSelected = this.fuelTypeOptions[1];

  searchControl = new FormControl('');

  filteredOptions!: Observable<SettingData[]>;

  plateNumber: string = '';

  driverList: any[] = [];
  filteredDriverList: any[] = [];
  driverSearchText: string = '';
  selectedDriver: any = null;
  insuranceCompany: string = '';
  sumInsuranceAmount: string = '';

  hasInsuranceoptions = [{name: 'Has Insurance', value: true}, {name: 'No Insurance', value: false}];
  hasInsuranceSelected = this.hasInsuranceoptions[0];
  hasInsuranceValue = {name: 'Has Insurance', value: true};

  yearMadeOptions: number[] = [];
  yearMadeSelected: number | null = null;

  engineNumber: string = '';
  chassisNumber: string = '';
  inspectionDate: string = '';
  inspectionExpiryDate: string = '';
  serviceDate: string = '';
  nextServiceDate: string = '';
  routeSelectedList: SettingData[] = [];
  routeExpertise: SettingData[] = [];
  isEdit: string = '';
  userData: any;
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  constructor(private globalVariable: GlobalVariablesService, private route: ActivatedRoute, private router: Router,
    private sharedService: SharedService, private apiService: APIService, public location: Location,
    private cdr: ChangeDetectorRef, private datePipe: DatePipe,
    private notification: NotificationService, public loadingService: LoadingService,
    private settingService: SettingService) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
    this.filteredOptions = this.searchControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || ''))
    );
  }

  async fetchImageAsFile(url: string, filename: string): Promise<File> {
    const response = await fetch(url);
    const blob = await response.blob();
    const mime = blob.type || 'image/jpeg';
    return new File([blob], filename, { type: mime });
  }

  ngOnInit(): void {
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= currentYear - 30; y--) {
      this.yearMadeOptions.push(y);
    }

    this.settingService.getSettings().subscribe(() => {
      this.setTruckTypeOptions();
      this.setTruckModelOptions();
      this.setTruckLoadCapacityOptions();
      this.setBoxSizeOptions();
      this.setBoxLoadingTypeOptions();
      this.setVehicleOptions();
      this.setIncidentReportOptions();
      this.setInsuranceOptions();
      this.setSecurityDepositeAmountOptions();
      this.setRouteExpertiseOptions();

      this.route.queryParams.subscribe(async params => {
        this.isEdit = params["isEdit"];
        if (this.isEdit == 'true') {
          try {
            this.userData = this.sharedService.getData();

            this.plateNumber = this.userData["plateNumber"] || '';
            this.insuranceCompany = this.userData["insuranceCompany"] || '';
            this.sumInsuranceAmount = this.formatAmount(this.userData["sumInsuranceAmount"] || '');
            this.hasInsuranceSelected = this.hasInsuranceoptions.find(option => option.value == this.userData["hasInsurance"]) || this.hasInsuranceoptions[0];
            this.hasInsuranceValue = this.hasInsuranceSelected;

            const routeExpertiseRaw = this.userData["routeExpertise"];
            const routeExpertiseIds = Array.isArray(routeExpertiseRaw)
              ? routeExpertiseRaw.map((v: any) => Number(v))
              : routeExpertiseRaw != null ? [Number(routeExpertiseRaw)] : [];
            this.routeSelectedList = this.globalVariable.SETTING_ROUTE_EXPERTISE.filter((data: any) => routeExpertiseIds.includes(Number(data.id)));

            const picturesRaw = this.userData["pictures"];
            const pictureList: string[] = Array.isArray(picturesRaw) ? picturesRaw : (picturesRaw ? [picturesRaw] : []);
            if (pictureList.length > 0) {
              const files = await Promise.all(
                pictureList.map((p: string) => this.fetchImageAsFile(environment.imageUrl + p, p.split('/').pop() || 'truck.jpg'))
              );
              this.selectedFilesList = files;
              this.selectedFiles = files[0];
            }

            if (this.userData["profilePicture"]) {
              const profilePicUrl = environment.imageUrl + this.userData["profilePicture"];
              this.truckProfilePicture = await this.fetchImageAsFile(profilePicUrl, this.userData["profilePicture"].split('/').pop() || 'profile.jpg');
            }

            if (this.userData["truckTypeId"]) {
              this.truckTypeSelectedValue = this.globalVariable.SETTING_TRUCK_TYPES.find((data: any) => Number(data.id) === Number(this.userData["truckTypeId"])) || { id: '', name: '' };
            }
            if (this.userData["truckModel"]) {
              this.truckModelSelectedValue = this.globalVariable.SETTING_TRUCK_MODEL_NUMBERS.find((role: any) => Number(role.id) === Number(this.userData["truckModel"])) || { id: '', name: '' };
            }
            if (this.userData["truckLoadingCapacity"]) {
              this.truckLoadCapacitySelectedValue = this.globalVariable.SETTING_TRUCK_LOADING_CAPACITY.find((role: any) => Number(role.id) === Number(this.userData["truckLoadingCapacity"])) || { id: '', name: '' };
            }
            if (this.userData["boxSize"]) {
              this.boxSizeSelectedValue = this.globalVariable.SETTING_BOX_SIZE.find((role: any) => Number(role.id) === Number(this.userData["boxSize"])) || { id: '', name: '' };
            }
            if (this.userData["boxLoadingType"]) {
              this.boxLoadingTypeSelectedValue = this.globalVariable.SETTING_BOX_LOADING_TYPES.find((role: any) => Number(role.id) === Number(this.userData["boxLoadingType"])) || { id: '', name: '' };
            }
            if (this.userData["vehicleMaintenance"]) {
              this.vehicleSelectedValue = this.globalVariable.SETTING_VEHICLE_MAINTENANCE.find((role: any) => Number(role.id) === Number(this.userData["vehicleMaintenance"])) || { id: '', name: '' };
            }
            if (this.userData["incidentReport"]) {
              this.incidentReportSelectedValue = this.globalVariable.SETTING_INCIDENT_REPORT.find((role: any) => Number(role.id) === Number(this.userData["incidentReport"])) || { id: '', name: '' };
            }
            if (this.userData["insuranceType"]) {
              this.typeInsuranceSelectedValue = this.globalVariable.SETTING_INSURANCE_TYPES.find((role: any) => Number(role.id) === Number(this.userData["insuranceType"])) || { id: '', name: '' };
            }
            if (this.userData["securityDepositAmount"]) {
              this.securityDepositeSelectedValue = this.globalVariable.SETTING_SECURITY_DEPOSIT_AMOUNT.find((role: any) => Number(role.id) === Number(this.userData["securityDepositAmount"])) || { id: '', name: '' };
            }

            this.yearMadeSelected = this.userData["yearMade"] ? Number(this.userData["yearMade"]) : null;
            this.engineNumber = this.userData["engineNumber"] || '';
            this.chassisNumber = this.userData["bodyChassisNumber"] || '';
            if (this.userData["inspectionDate"]) {
              this.inspectionDate = this.datePipe.transform(new Date(this.userData["inspectionDate"]), 'yyyy-MM-dd') || '';
            }
            if (this.userData["inspectionExpireDate"]) {
              this.inspectionExpiryDate = this.datePipe.transform(new Date(this.userData["inspectionExpireDate"]), 'yyyy-MM-dd') || '';
            }
            if (this.userData["serviceDate"]) {
              this.serviceDate = this.datePipe.transform(new Date(this.userData["serviceDate"]), 'yyyy-MM-dd') || '';
            }
            if (this.userData["nextServiceDate"]) {
              this.nextServiceDate = this.datePipe.transform(new Date(this.userData["nextServiceDate"]), 'yyyy-MM-dd') || '';
            }
            this.gpsSelected = this.gpsOptions.find(o => o.value === this.userData["hasGps"]) ?? this.gpsOptions[1];
            this.cameraSelected = this.cameraOptions.find(o => o.value === this.userData["hasCamera"]) ?? this.cameraOptions[1];
            this.fuelTypeSelected = this.fuelTypeOptions.find(o => o.value === this.userData["fuelType"]) ?? this.fuelTypeOptions[1];

            this.cdr.detectChanges();
          } catch (error) {
            console.error('Error mapping user data:', error);
            this.onReset();
          }
        } else {
          this.onReset();
        }
        this.getDriverList();
      });
    });
  }

  setTruckTypeOptions() {
    this.truckTypeOptions = [...(this.globalVariable.SETTING_TRUCK_TYPES || [])];
  }
  setTruckModelOptions() {
    this.truckModelOptions = [...(this.globalVariable.SETTING_TRUCK_MODEL_NUMBERS || [])];
    this.filteredTruckModelOptions = [...this.truckModelOptions];
  }

  onTruckModelSelectOpened(opened: boolean): void {
    if (opened) {
      this.truckModelSearchText = '';
      this.filteredTruckModelOptions = [...this.truckModelOptions];
    }
  }

  filterTruckModelList(): void {
    const search = this.truckModelSearchText.toLowerCase();
    this.filteredTruckModelOptions = this.truckModelOptions.filter(option =>
      option.name.toLowerCase().includes(search)
    );
  }

  setTruckLoadCapacityOptions() {
    this.truckLoadCapacityOptions = [...(this.globalVariable.SETTING_TRUCK_LOADING_CAPACITY || [])];
  }
  setBoxSizeOptions() {
    this.boxSizeOptions = [...(this.globalVariable.SETTING_BOX_SIZE || [])];
  }
  setBoxLoadingTypeOptions() {
    this.boxLoadingTypeOptions = [...(this.globalVariable.SETTING_BOX_LOADING_TYPES || [])];
  }
  setVehicleOptions() {
    this.vehicleOptions = [...(this.globalVariable.SETTING_VEHICLE_MAINTENANCE || [])];
  }
  setIncidentReportOptions() {
    this.incidentReportOptions = [...(this.globalVariable.SETTING_INCIDENT_REPORT || [])];
  }
  setInsuranceOptions() {
    this.typeInsuranceOptions = [...(this.globalVariable.SETTING_INSURANCE_TYPES || [])];
  }
  setSecurityDepositeAmountOptions() {
    this.securityDepositeAmountOptions = [...(this.globalVariable.SETTING_SECURITY_DEPOSIT_AMOUNT || [])];
  }
  setRouteExpertiseOptions() {
    this.routeExpertise = [...(this.globalVariable.SETTING_ROUTE_EXPERTISE || [])];
  }

  getDriverList() {
    this.driverList = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!);
    this.apiService.get('/api/drivers/available/list', loginData.token).subscribe({
      next: (response) => {
        if (response.status === 200) {
          response.body.drivers.forEach((data: any) => {
            this.driverList.push({
              ...data,
              driverPicURL: environment.imageUrl + data['picture'],
            });
          });

          if (this.isEdit === 'true' && this.userData?.driverId && this.userData?.driver
            && !this.driverList.some(d => d.id === this.userData.driverId)) {
            this.driverList.unshift({
              ...this.userData.driver,
              driverPicURL: environment.imageUrl + this.userData.driver['picture'],
            });
          }

          this.filteredDriverList = [...this.driverList];

          if (this.isEdit === 'true' && this.userData?.driverId) {
            this.selectedDriver = this.driverList.find(d => d.id === this.userData.driverId) || null;
          }
        }
      },
      error: (error) => {
        console.error('Error fetching drivers:', error);
      }
    });
  }

  onDriverSelect(driver: any) {
    this.selectedDriver = driver;
  }

  onDriverSelectOpened(opened: boolean): void {
    if (opened) {
      this.driverSearchText = '';
      this.filteredDriverList = [...this.driverList];
    }
  }

  filterDriverList(): void {
    const search = this.driverSearchText.toLowerCase();
    this.filteredDriverList = this.driverList.filter(driver => {
      const name = (driver.englishName || driver.khmerName || '').toLowerCase();
      const phone = (driver.primaryContactNumber || '').toLowerCase();
      return name.includes(search) || phone.includes(search);
    });
  }

  compareById(a: SettingData, b: SettingData): boolean {
    return a && b ? Number(a.id) === Number(b.id) : a === b;
  }

  private _filter(value: string): SettingData[] {
    const filterValue = value.toLowerCase();
    return this.routeExpertise
      .filter(option => option.name.toLowerCase().includes(filterValue))
      .filter(option => !this.routeSelectedList.includes(option));
  }

  addSelection(option: SettingData) {
    const exists = this.routeSelectedList.some(item => item.id === option.id);
    if (!exists) {
      this.routeSelectedList.push(option);
      this.searchControl.setValue('');
    }
  }

  remove(data: SettingData) {
    this.routeSelectedList = this.routeSelectedList.filter(obj => obj.id !== data.id);
  }

  onProfilePictureSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.truckProfilePicture = input.files[0];
      input.value = '';
    }
  }

  removeProfilePicture(): void {
    this.truckProfilePicture = null;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      const newFiles = Array.from(input.files);
      this.selectedFilesList = [...this.selectedFilesList, ...newFiles];
      this.selectedFiles = this.selectedFilesList[0];
      input.value = '';
    }
  }

  removeImage(index: number): void {
    this.selectedFilesList = this.selectedFilesList.filter((_, i) => i !== index);
    this.selectedFiles = this.selectedFilesList[0];
  }

  getImageUrl(file: File): string {
    return URL.createObjectURL(file);
  }

  submitButtonAction() {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    if (this.truckTypeSelectedValue.id.length > 1) {
      this.notification.warning('Please select Truck Type!');
      return;
    }
    if (this.truckModelSelectedValue.id.length < 1) {
      this.notification.warning('Please select Truck Model!');
      return;
    }
    if (this.truckLoadCapacitySelectedValue.id.length < 1) {
      this.notification.warning('Please select Truck Load Capacity!');
      return;
    }
    if (this.boxSizeSelectedValue.id.length < 1) {
      this.notification.warning('Please select Box Size!');
      return;
    }
    if (this.boxLoadingTypeSelectedValue.id.length < 1) {
      this.notification.warning('Please select Box Loading Type!');
      return;
    }
    if (this.vehicleSelectedValue.id.length < 1) {
      this.notification.warning('Please select Vehicle Maintenance!');
      return;
    }
    if (this.incidentReportSelectedValue.id.length < 1) {
      this.notification.warning('Please select Incident Report!');
      return;
    }
    if (this.hasInsuranceValue.value && this.typeInsuranceSelectedValue.id.length < 1) {
      this.notification.warning('Please select Type of Insurance!');
      return;
    }
    if (this.securityDepositeSelectedValue.id.length < 1) {
      this.notification.warning('Please select Security Deposit Amount!');
      return;
    }
    if (this.plateNumber.length < 1) {
      this.notification.warning('Please enter Plate Number!');
      return;
    }
    if (!this.selectedDriver) {
      this.notification.warning('Please select a Driver!');
      return;
    }
    if (this.hasInsuranceValue.value && this.insuranceCompany.length < 1) {
      this.notification.warning('Please enter Insurance Company!');
      return;
    }
    if (this.hasInsuranceValue.value && this.sumInsuranceAmount.length < 1) {
      this.notification.warning('Please enter Sum Insurance Amount!');
      return;
    }
    if (this.routeSelectedList.length < 1) {
      this.notification.warning('Please select at least one Route Expertise!');
      return;
    }
    let jsonData: any = {
      profilePicture: this.truckProfilePicture,
      pictures: this.selectedFilesList,
      truckTypeId: this.truckTypeSelectedValue.id,
      truckModelNumber: this.truckModelSelectedValue.id,
      truckLoadingCapacity: this.truckLoadCapacitySelectedValue.id,
      boxSize: this.boxSizeSelectedValue.id,
      boxLoadingType: this.boxLoadingTypeSelectedValue.id,
      vehicleMaintenance: this.vehicleSelectedValue.id,
      incidentReport: this.incidentReportSelectedValue.id,
      insuranceType: this.typeInsuranceSelectedValue.id,
      securityDepositAmount: this.securityDepositeSelectedValue.id,
      plateNumber: this.plateNumber,
      driverId: this.selectedDriver?.id,
      contactName: this.selectedDriver?.englishName || this.selectedDriver?.khmerName,
      contactPrimaryNumber: this.selectedDriver?.primaryContactNumber,
      insuranceCompany: this.insuranceCompany,
      sumInsuranceAmount: this.sumInsuranceAmount.replace(/,/g, ''),
      hasInsurance: this.hasInsuranceValue.value,
      hasGps: this.gpsSelected.value,
      hasCamera: this.cameraSelected.value,
      fuelType: this.fuelTypeSelected.value,
      yearMade: this.yearMadeSelected || null,
      engineNumber: this.engineNumber || null,
      bodyChassisNumber: this.chassisNumber || null,
      inspectionDate: this.inspectionDate || null,
      inspectionExpireDate: this.inspectionExpiryDate || null,
      serviceDate: this.serviceDate || null,
      nextServiceDate: this.nextServiceDate || null,
      routeExpertise: this.routeSelectedList ? this.routeSelectedList.map((route: SettingData) => route.id) : '',
      isActive: true,
      remark: ""
    }
    console.log('Submitting data:', jsonData);
    let endpoint = '';
    if (this.isEdit == 'true') {
      endpoint = '/api/trucks/' + this.userData["id"];
      this.apiService.putFormData(endpoint, jsonData, loginData.token)
        .subscribe({
          next: (response: HttpResponse<any>) => {
            if (response.status === 200) {
              this.notification.success('Update Truck successfully');
              this.location.back();
            } else {
              this.notification.error(response.body?.message || 'Update Truck failed. Please try again.');
            }
          },
          error: err => {
            console.error('Error:', err);
            this.notification.error(err.error?.message || 'Update Truck failed. Please try again.');
          }
        });
    } else {
      endpoint = '/api/trucks/register';
      this.apiService.postFormData(endpoint, jsonData, loginData.token).subscribe({
        next: response => {
          if (response.status === 200 || response.status === 201) {
            this.notification.success('Truck registered successfully');
            this.location.back();
          } else {
            this.notification.error((response.body as any)?.message || 'Register truck failed. Please try again.');
          }
        },
        error: error => {
          console.error('Error:', error);
          this.notification.error(error.error?.message || 'Register truck failed. Please try again.');
        }
      });
    }
  }

  onReset() {
    this.truckTypeSelectedValue = { id: '', name: '' };
    this.truckModelSelectedValue = { id: '', name: '' };
    this.yearMadeSelected = null;
    this.truckModelSearchText = '';
    this.filteredTruckModelOptions = [...this.truckModelOptions];
    this.truckLoadCapacitySelectedValue = { id: '', name: '' };
    this.boxSizeSelectedValue = { id: '', name: '' };
    this.boxLoadingTypeSelectedValue = { id: '', name: '' };
    this.vehicleSelectedValue = { id: '', name: '' };
    this.incidentReportSelectedValue = { id: '', name: '' };
    this.typeInsuranceSelectedValue = { id: '', name: '' };
    this.securityDepositeSelectedValue = { id: '', name: '' };
    this.selectedFiles = new File([], '');
    this.selectedFilesList = [];
    this.truckProfilePicture = null;
    this.searchControl.setValue('');
    this.routeSelectedList = [];
    this.plateNumber = '';
    this.selectedDriver = null;
    this.driverSearchText = '';
    this.filteredDriverList = [...this.driverList];
    this.insuranceCompany = '';
    this.sumInsuranceAmount = '';
    this.hasInsuranceValue = this.hasInsuranceoptions[0];
    this.gpsSelected = this.gpsOptions[1];
    this.cameraSelected = this.cameraOptions[1];
    this.fuelTypeSelected = this.fuelTypeOptions[1];
    this.engineNumber = '';
    this.chassisNumber = '';
    this.inspectionDate = '';
    this.inspectionExpiryDate = '';
    this.serviceDate = '';
    this.nextServiceDate = '';
    this.routeSelectedList = [];
  }

  formatAmount(value: string): string {
    const cleaned = value.replace(/[^0-9.]/g, '');
    const parts = cleaned.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.length > 1 ? parts[0] + '.' + parts[1] : parts[0];
  }

  onInsuranceAmountInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const cursorPos = input.selectionStart ?? 0;
    const prevLen = input.value.length;
    this.sumInsuranceAmount = this.formatAmount(input.value);
    const diff = this.sumInsuranceAmount.length - prevLen;
    setTimeout(() => input.setSelectionRange(cursorPos + diff, cursorPos + diff));
  }

  onCancel() {
    this.onReset();
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }
}
